import { render, staticRenderFns } from "./SolicitacaoAjusteParcial.vue?vue&type=template&id=7f730ff2&scoped=true&"
import script from "./SolicitacaoAjusteParcial.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoAjusteParcial.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacaoAjusteParcial.vue?vue&type=style&index=0&id=7f730ff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f730ff2",
  null
  
)

export default component.exports